module.exports = __webpack_public_path__ + "static/media/p-mcvey-building-systems.8dc14da4.jpg";